import CustomFilterType from "../models/CustomFilterType";
import CustomQuery from "../models/CustomQuery";

const emptyQuery = (): CustomQuery => ({ filters: [] });

const parseCustomQuery = (savedValue?: string): CustomQuery => {
    if (!savedValue) {
        return emptyQuery();
    }

    try {
        const parsed = JSON.parse(savedValue);
        return Array.isArray(parsed?.filters) ? parsed : emptyQuery();
    } catch (e) {
        console.error("Failed to parse saved custom query", e);
        return emptyQuery();
    }
};

const hydrateCustomQuery = (
    savedValue: string | undefined,
    availableFilters: CustomFilterType[]
): CustomQuery => {
    const query = parseCustomQuery(savedValue);

    return {
        filters: query.filters.map(savedFilter => {
            const definition = availableFilters.find(filter => filter.type === savedFilter.type);
            if (!definition) {
                return savedFilter;
            }

            return {
                ...definition,
                ...savedFilter,
                grouping: definition.grouping,
                reportTypes: definition.reportTypes,
                dataType: definition.dataType,
                isExtenalLookup: definition.isExtenalLookup,
                name: definition.name,
                possibleValues: definition.possibleValues
            };
        })
    };
};

export {
    hydrateCustomQuery,
    parseCustomQuery
};
